import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {Link} from 'react-router-dom';

import AskReinforcement from '../../../components/AskReinforcement/AskReinforcement.jsx';
import CalendlyButton from '../../../components/CalendlyButton/CalendlyButton.jsx';
import Header from '../../../components/Header/Header.jsx';
import LandingUniverse from '../LandingUniverse.jsx';
import OurDifferences from '../../../components/OurDifferences/OurDifferences.jsx';
import OurJobs from '../../../components/OurJobs/OurJobs.jsx';
import References from '../../../components/References/References.jsx';

import {generate} from '../../../routes.js';
import conf from '../../../conf.js';

import person from './images/person.svg';

class LandingCompanyUniverse extends PureComponent {
  static propTypes = {
    headerBrief: PropTypes.element.isRequired,
    headerImg: PropTypes.string.isRequired,
    metaDescription: PropTypes.string.isRequired,
    metaOgDescription: PropTypes.string.isRequired,
    metaOgTitle: PropTypes.string.isRequired,
    metaTitle: PropTypes.string.isRequired,
    ourJobsItems: PropTypes.array.isRequired,
    specificDifference: PropTypes.element.isRequired,
    title: PropTypes.string.isRequired,
    universeCode: PropTypes.string,
  };

  static defaultProps = {
    ourJobsItems: [],
    specificDifference: null,
    universeCode: null,
  };

  render() {
    const {currentUniverse, headerBrief, headerImg, title, ...props} = this.props;

    const headerCtas = <Fragment>
      <Link className="btn btn-primary" to={generate({name: 'drop-need'})}>Proposer un mandat</Link>
      <CalendlyButton className="btn btn-secondary" meetingUrl={conf.calendly.do}>Être rappelé(e)</CalendlyButton>
    </Fragment>;

    return <LandingUniverse {...props} className="landing-company">
      <Helmet>
        <title>{props.metaTitle}</title>
        <meta name="description" content={props.metaDescription}/>
        <meta property="og:title" content={props.metaOgTitle}/>
        <meta property="og:description" content={props.metaOgDescription}/>
        <meta property="twitter:title" content={props.metaOgTitle}/>
        <meta property="twitter:description" content={props.metaOgDescription}/>
      </Helmet>

      <Header
        brief={headerBrief}
        ctas={headerCtas}
        imageAlt={''}
        imageSrc={headerImg}
        title={title}
      />

      <div className="bg-light">
        <References className="container text-center py-5"/>
      </div>

      <OurJobs items={props.ourJobsItems}/>

      <div className="bg-light">
        <AskReinforcement universeCode={props.universeCode}/>
      </div>

      <OurDifferences specificDifference={props.specificDifference}/>

      <div className="bg-light">
        <section id="benefits">
          <div className="container py-5">
            <div className="row text-center">
              <div className="col-md-10 offset-md-1 mb-4 mb-md-0">
                <img className="mb-4" src={person} alt={''}/>
                <h3>100% de consultants qualifiés</h3>
                <p>
                  Tous nos consultants ont été rencontrés et qualifiés par des professionnels de LEUR métier, afin de
                  vous assurer de la réelle adéquation entre vos besoins et leurs qualifications.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </LandingUniverse>;
  }
}

export default connect(
  state => ({
    currentUniverse: state.universe.currentUniverse,
  }),
)(LandingCompanyUniverse);
